import { IAppState } from '../../../../common/state';

export function botCathcerLinksSelector({ seoBotCatcherLinks }: IAppState) {
  return seoBotCatcherLinks;
}
